import React from "react";
import { Helmet } from "react-helmet";

import Footer from "../../component/common/Footer";
import HeroSection from "./HeroSection";
import ContactCards from "./ContactCards";
import ContactForm from "./ContactForm";

const Contact = () => {
  return (
    <>
      <Helmet>
        <title>
          Contact Govardhannathji Energies LLP | Industrial Energy Solutions
          Provider
        </title>
        <meta
          name="description"
          content="Get in touch with Govardhannathji Energies LLP for comprehensive industrial energy solutions. Contact our expert team for renewable energy, power systems, and sustainable industrial solutions."
        />
        <meta
          property="og:title"
          content="Contact Govardhannathji Energies LLP | Industrial Energy Solutions Provider"
        />
        <meta
          property="og:description"
          content="Get in touch with Govardhannathji Energies LLP for comprehensive industrial energy solutions. Contact our expert team for renewable energy, power systems, and sustainable industrial solutions."
        />
      </Helmet>

      <main className="flex flex-col  md:gap-[60px] lg:gap-[80px] justify-start items-center w-full bg-white">
        <HeroSection />
        {/* <ContactCards />
        <ContactForm /> */}
      </main>
      <Footer />
    </>
  );
};

export default Contact;
